import { MessageBarType } from '@fluentui/react'
import { createReducer } from 'typesafe-actions'
import {
  IBreakDetailAttrCountRes,
  IInsertUpdateSuppressMessageApiRes,
  IReconDetailsRes,
  IReconSummarySearchState,
  ISetAPIResponseOutput
} from '../api/types'
import {
  addCommentsReconActions,
  fetchBreakDetailAttrActions,
  fetchReconDetailsActions,
  fetchResolvedCountActions,
  ReconDataActionsTypes,
  reconSummarySearchActions,
  groupUsersActions
} from './actions'

export interface IReconDataState {
  getReconDataDetailsState?: {
    inProgress: boolean
    errorCode?: string
    msg?: string
    messageType?: MessageBarType
    data?: IReconDetailsRes
  }
  isDetailedViewOpen?: boolean
  addCommentReconDataState?: {
    inProgress: boolean
    error?: Error
    messageType?: MessageBarType
    msg?: string
    data?: ISetAPIResponseOutput
    eventCode?: string
    isSeiRequest?: boolean
  }
  insertUpdateSuppressMessageState?: {
    inProgress: boolean
    error?: Error
    msg?: string
    messageType?: MessageBarType
    data?: IInsertUpdateSuppressMessageApiRes
  }
  fetchBreakDetailAttrCountState?: {
    inProgress: boolean
    error?: Error
    data?: IBreakDetailAttrCountRes
  }
  resolvedCountState?: {
    inProgress: boolean
    error?: Error
    count?: number
  }
  reconSummarySearchState?: IReconSummarySearchState
  groupUsersState?: {
    users: any[]
  }
  activeTab?: string
}
const initialState: IReconDataState = {
  isDetailedViewOpen: false,
  activeTab: 'ALL'
}
export const reconDataSummaryReducer = createReducer<
  IReconDataState,
  ReconDataActionsTypes
>(initialState)
  .handleAction(fetchReconDetailsActions.request, (state) => ({
    ...state,
    getReconDataDetailsState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchReconDetailsActions.success, (state, action) => ({
    ...state,
    getReconDataDetailsState: {
      inProgress: false,
      error: undefined,
      data: action.payload,
      messageType: MessageBarType.success
    }
  }))
  .handleAction(fetchReconDetailsActions.failure, (state, action) => ({
    ...state,
    getReconDataDetailsState: {
      inProgress: false,
      error: action.payload,
      data: undefined,
      messageType: MessageBarType.error
    }
  }))
  .handleAction(fetchReconDetailsActions.clear, (state) => ({
    ...state,
    getReconDataDetailsState: undefined
  }))
  .handleAction(
    addCommentsReconActions.setDetailedViewOpen,
    (state, action) => ({
      ...state,
      isDetailedViewOpen: action.payload
    })
  )
  .handleAction(addCommentsReconActions.setActiveTab, (state, action) => ({
    ...state,
    activeTab: action.payload
  }))
  .handleAction(addCommentsReconActions.request, (state, action) => ({
    ...state,
    addCommentReconDataState: {
      ...state.addCommentReconDataState,
      inProgress: true,
      error: undefined,
      messageType: MessageBarType.info,
      msg: undefined,
      eventCode: action.payload.eventCode,
      isSeiRequest: action.payload.isSeiRequest
    }
  }))
  .handleAction(addCommentsReconActions.success, (state, action) => ({
    ...state,
    addCommentReconDataState: {
      inProgress: false,
      error: undefined,
      messageType: MessageBarType.success,
      msg: 'Successfully saved.',
      data: action.payload,
      eventCode: state.addCommentReconDataState?.eventCode,
      isSeiRequest: state.addCommentReconDataState?.isSeiRequest
    }
  }))
  .handleAction(addCommentsReconActions.failure, (state, action) => ({
    ...state,
    addCommentReconDataState: {
      ...state.addCommentReconDataState,
      inProgress: false,
      error: action.payload,
      msg: action.payload.message,
      messageType: MessageBarType.error,
      eventCode: state.addCommentReconDataState?.eventCode,
      isSeiRequest: state.addCommentReconDataState?.isSeiRequest
    }
  }))
  .handleAction(addCommentsReconActions.clear, (state) => ({
    ...state,
    addCommentReconDataState: undefined
  }))
  .handleAction(reconSummarySearchActions.request, (state) => ({
    ...state,
    reconSummarySearchState: {
      ...state.reconSummarySearchState,
      inProgress: true,
      error: undefined
    }
  }))
  .handleAction(reconSummarySearchActions.success, (state, action) => ({
    ...state,
    reconSummarySearchState: {
      inProgress: false,
      reconSummarySearchList: action.payload,
      error: undefined
    }
  }))
  .handleAction(reconSummarySearchActions.failure, (state, action) => ({
    ...state,
    reconSummarySearchState: {
      inProgress: false,
      reconSummarySearchList: undefined,
      error: action.payload
    }
  }))
  .handleAction(reconSummarySearchActions.clear, (state) => ({
    ...state,
    reconSummarySearchState: undefined
  }))

  .handleAction(fetchBreakDetailAttrActions.request, (state) => ({
    ...state,
    fetchBreakDetailAttrCountState: {
      inProgress: true,
      error: undefined,
      data: undefined
    }
  }))
  .handleAction(fetchBreakDetailAttrActions.success, (state, action) => ({
    ...state,
    fetchBreakDetailAttrCountState: {
      inProgress: false,
      error: undefined,
      data: action.payload
    }
  }))
  .handleAction(fetchBreakDetailAttrActions.failure, (state, action) => ({
    ...state,
    fetchBreakDetailAttrCountState: {
      inProgress: false,
      error: action.payload,
      data: undefined
    }
  }))
  .handleAction(fetchBreakDetailAttrActions.clear, (state) => ({
    ...state,
    fetchBreakDetailAttrCountState: undefined
  }))
  .handleAction(groupUsersActions.set, (state, action) => ({
    ...state,
    groupUsersState: {
      users: action.payload.users
    }
  }))
  .handleAction(groupUsersActions.clear, (state) => ({
    ...state,
    groupUsersState: undefined
  }))
  .handleAction(fetchResolvedCountActions.request, (state) => ({
    ...state,
    resolvedCountState: {
      inProgress: true,
      error: undefined,
      count: undefined
    }
  }))
  .handleAction(fetchResolvedCountActions.success, (state, action) => ({
    ...state,
    resolvedCountState: {
      inProgress: false,
      error: undefined,
      count: action.payload
    }
  }))
  .handleAction(fetchResolvedCountActions.failure, (state, action) => ({
    ...state,
    resolvedCountState: {
      inProgress: false,
      error: action.payload,
      count: undefined
    }
  }))
  .handleAction(fetchResolvedCountActions.clear, (state) => ({
    ...state,
    resolvedCountState: undefined
  }))
